var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowBendDownLeft = function SvgIconArrowBendDownLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21 4.25a1 1 0 0 1 1 1 10 10 0 0 1-10 10H5.414l2.793 2.793a1 1 0 1 1-1.414 1.414l-4.5-4.5a1 1 0 0 1 0-1.414l4.5-4.5a1 1 0 0 1 1.414 1.414L5.414 13.25H12a8 8 0 0 0 8-8 1 1 0 0 1 1-1"
  })));
};
export default SvgIconArrowBendDownLeft;